export default class Product extends HTMLElement {
  id: string
  shopifyUrl: string

  productIdEl: HTMLInputElement | null = null
  checkoutButtonEl: HTMLElement | null = null
  sizeEl: HTMLElement | null = null
  priceEl: HTMLElement | null = null

  constructor() {
    super()

    this.id = this.getAttribute('id') ?? ''
    this.shopifyUrl = this.getAttribute('shopify-url') ?? ''

    console.log(this.id, this.shopifyUrl)
  }

  connectedCallback() {
    this.productIdEl = this.querySelector('input[name="id"]')
    this.checkoutButtonEl = this.querySelector('[data-checkout]')
    this.sizeEl = this.querySelector('[data-size]')
    this.priceEl = this.querySelector('[data-price]')

    if (this.checkoutButtonEl) {
      this.checkoutButtonEl.addEventListener('click', this.handleCheckoutClick.bind(this))
    }

    if (this.sizeEl) {
      this.sizeEl.addEventListener('change', this.handleSizeChange.bind(this))
    }
  }

  get variantId() {
    return this.id
  }

  set variantId(value: string) {
    this.id = value
    this.setAttribute('id', value)

    if (this.productIdEl) {
      this.productIdEl.value = value
    }

  }

  handleSizeChange(evt: Event) {
    const target = evt.target as HTMLSelectElement

    // update the variant id

    this.variantId = target.value

    const option = target.options[target.selectedIndex]

    if (this.priceEl && option) {
      const price = option.getAttribute('data-price') ?? false

      if (price) {
        this.priceEl.textContent = `(${price})`
      }
    }
  }

  // Checkout button shouldn't submit the form

  handleCheckoutClick(evt: Event) {
    evt.preventDefault()

    const url = `${this.shopifyUrl}/cart/${this.id}:1`

    window.location.href = url

    console.log('Checkout clicked')
  }
}

customElements.define('shop-product', Product)